// extracted by mini-css-extract-plugin
export default {"productCapabilitiesWrapper":"styles_productCapabilitiesWrapper__CdokB","contentWrapper":"styles_contentWrapper__Xw0wU"};